import React, {useEffect, useRef} from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Button,
  InputGroup,
  InputGroupAddon,
  FormCheckbox,
  FormInput
} from "shards-react";


export default function SidebarCategories({ formCategories, setter }) {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const categoriesInput = useRef(null);
  const allCategories = useSelector(state => state.articles.categories);

  useEffect(() => {
    setCategories(allCategories);
  }, [allCategories]);

  const toggleFormCategories = (e) => {
    if (e.target.checked) {
      formCategories.push(e.target.value);
    } else {
      formCategories = formCategories.filter(category => category !== e.target.value);
    }
    setter(formCategories);
  };

  useEffect(() => {
    if (formCategories !== undefined) {
      for (let label of categoriesInput.current.children) {
        if (formCategories.includes(label.children[0].value)) {
          label.children[0].checked = true;
        }
      }
    }
  });

  const handleAddCategory = () => {
    if (newCategory.trim() !== '') {
      setCategories([...categories, { value: newCategory, label: newCategory  }]);
      setNewCategory('');
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleAddCategory();
    }
  };

  return (
    <Card small className="mb-3">
      <CardHeader className="border-bottom">
        <h6 className="m-0">Categories</h6>
      </CardHeader>
      <CardBody className="p-0">
        <ListGroup flush>
          <li className="px-3 pb-2 list-group-item" ref={categoriesInput}>
            {
              categories && categories.length != 0 &&
              categories.map((cat, index) => (
                <label key={index} className="mb-1 text-capitalize d-block">
                  <input
                    type="checkbox"
                    onChange={toggleFormCategories}
                    value={cat.label}
                  />
                  {" " + cat.label}
                </label>
              ))
            }
          </li>

          <ListGroupItem className="d-flex px-3">
            <InputGroup className="ml-auto">
              <FormInput placeholder="New category" value={newCategory} onChange={(e) => setNewCategory(e.target.value)} onKeyPress={handleKeyPress}/>
              <InputGroupAddon type="append">
                <Button theme="white" className="px-2" onClick={handleAddCategory}>
                  <i className="material-icons">add</i>
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </Card>
  )
}
